export enum Sex {
    male = 'male',
    female = 'female'
}

export enum AgeGroup {
    adult = 'adult',
    child = 'child'
}

export enum BodyShape {
    average = 'average',
    corpulent = 'corpulent',
    custom = 'custom'
}

export class ModelType {
    private _sex: Sex;
    private _shape: BodyShape;
    private _ageGroup: AgeGroup;
    private _height: number;

    constructor(model?: any) {
        if (model) {
            this._sex = model.Sex;
            this._ageGroup = model.AgeGroup;
            this._shape = model.BodyShape;
            this._height = model.height;
            this._weight = model.weight;
        } else {
            this._sex = Sex.male;
            this._ageGroup = AgeGroup.adult;
            this._shape = BodyShape.average;
            this._height = 178.8;
            this._weight = 60;
        }
    }

    private _weight: number;

    get sex(): Sex {
        return this._sex;
    }

    set sex(value: Sex) {
        this._sex = value;
    }



    get ageGroup(): AgeGroup {
        return this._ageGroup;
    }

    set ageGroup(value: AgeGroup) {
        this._ageGroup = value;
    }


    get shape(): BodyShape {
        return this._shape;
    }

    set shape(value: BodyShape) {
        this._shape = value;
    }


    get height(): number {
        return this._height;
    }

    set height(value: number) {
        this._height = value;
    }

    get weight(): number {
        return this._weight;
    }

    set weight(value: number) {
        this._weight = value;
    }

    toString() {
        if (this._sex.valueOf() && this._ageGroup.valueOf()) {
            return this._sex.valueOf() + '_' + this._ageGroup.valueOf();
        }
        return null;
    }
}
